import { Grid } from "@mui/material";

import { Entry } from "../dashboard";
import StoreCard from "../../../components/retial_application_card/store_card";

const CardsView = ({ entries, onDelete }: any) => {
  return (
    <Grid mx={1}>
      {entries.map((entry: Entry, index: number) => (
        <StoreCard
          key={index}
          entryId={entry.id}
          imageUrl="https://via.placeholder.com/150"
          storeName={entry.storeName}
          storeCity={entry.storeCity}
          storeState={entry.storeInformationData.storeState}
          legalCorpName={entry.corporationInformationData.legalCorpName}
          licenseGeneratedDate={entry.licenseGeneratedDate}
          leaseGeneratedDate={entry.leaseGeneratedDate}
          applicationGeneratedDate={entry.applicationGeneratedDate}
          markedReceivedDate={entry.markedReceivedDate}
          docsGeneratedBy={entry.docsGeneratedBy}
          markedReceivedBy={entry.markedReceivedBy}
          onDelete={onDelete}
        />
      ))}
    </Grid>
  );
};

export default CardsView;
